export default "__VITE_ASSET__EU2S6dev__"